/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useEffect, useState, useRef } from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import { View, StatusBar, Image, Platform } from 'react-native';
import { Asset } from 'expo-asset';
import { NavigationContainer, DefaultTheme } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import interceptorsSetup from './interceptors';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { PortalHost, PortalProvider } from '@gorhom/portal';
import store from '@/store';
import Colors from '@global/colors';
import {
  ENV,
  VERSION,
  IS_SIMULATOR,
  NET_DOMAIN,
  COOKIES_DOMAIN,
  COOKIES_EXPIRY,
} from '@constants';
import { TOAST_PROPS, TOAST_CONFIG } from '@constants/toast-config';
import B2bRouting from '@global/web-routing';
import CacheImages from '@constants/cache-images';
import Toast from 'react-native-toast-message';
import RootNavigator from '@/navigation/RootNavigator';
import AuthNavigator from '@/navigation/AuthNavigator';
import SociollaText from '@/components/sociolla/SociollaText';
import FullLoader from '@/components/global/FullLoader';
import Alert from '@/components/global/Alert';
import ModalImage from '@/components/modal/ModalImage';
import ForceUpdateModal from '@/components/ForceUpdateModal';

import { userMe, logout } from '@/store/auth/actions';
import {
  setRoute as actionRoute,
  showForceUpdate,
  setAppVersion,
} from '@/store/global';
import msPublicApi from '@/api/ms-soco-public-api';
import semverGt from 'semver/functions/gt';
import semverValid from 'semver/functions/valid';
import { isIos, isNative, isWebPlatform, isWeb } from '@global/screens';
import { getVersion } from 'react-native-device-info';
import { logEventScreen } from '@global/analytics';
import crashlytics from '@/plugins/crashlytics';
import { requestTrackingPermission } from 'react-native-tracking-transparency';

import NetInfo from '@react-native-community/netinfo';
import { showAlert as AlertShow, hideAlert } from '@/store/global';
import { getEnvironment, getGoogleMapKey, isVn } from '@global/helpers';
import SyncStorage from '@global/storage';
import { setLanguage, LANGUAGE_STORAGE_KEY } from '@/store/language';

let NetworkLoggerFloating;

if (isNative) {
  SplashScreen.preventAutoHideAsync().catch(() => {});
}

if (isNative) {
  try {
    NetworkLoggerFloating =
      require('@/components/global/NetworkLoggerFloating').default;
  } catch (e) {}
}

const Config = getEnvironment();
const isShowingLogger = (!!Config.ENABLE_NETWORK_LOGGER && isNative) || false;

// define global variable
global.validate = require('validate.js');
global.validate.validators.presence.options = { message: 'not filled' };
global.pageBase = '';
global.pageFrom = '';
global.pagePrevFrom = '';
global.currentPage = '';
global.previousPage = '';
global.isFromAdded = false;

let internet = true;

function cacheFonts() {
  return Font.loadAsync({
    // 'gotham-book': require('@assets/fonts/gotham/Gotham-Book.otf'),
    // 'gotham-medium': require('@assets/fonts/gotham/Gotham-Medium.otf'),
    // 'gotham-bold': require('@assets/fonts/gotham/Gotham-Bold.otf'),
    // 'gotham-htf-medium': require('@assets/fonts/gotham/GothamHTF-Medium.otf'),
    'figtree-extraBold': require('@assets/fonts/figtree/Figtree-ExtraBold.ttf'),
    'figtree-bold': require('@assets/fonts/figtree/Figtree-Bold.ttf'),
    'figtree-semiBold': require('@assets/fonts/figtree/Figtree-SemiBold.ttf'),
    'figtree-medium': require('@assets/fonts/figtree/Figtree-Medium.ttf'),
    'figtree-regular': require('@assets/fonts/figtree/Figtree-Regular.ttf'),
  });
}

function cacheImages(images) {
  return images.map((image) => {
    if (typeof image === 'string') {
      return Image.prefetch(image);
    } else {
      return Asset.fromModule(image).downloadAsync();
    }
  });
}

const fetchAssets = async () => {
  const imageAssets = cacheImages(CacheImages);

  const fontAssets = cacheFonts();

  await Promise.all([...imageAssets, fontAssets]);
};

const createGtmScript = () => {
  const gtm_script_check = document.getElementById('gtm-script');
  if (!gtm_script_check) {
    const gtm_script = document.createElement('script');
    gtm_script.id = 'gtm-script';
    gtm_script.defer = true;
    gtm_script.type = 'text/javascript';
    gtm_script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-N2W36V3');`;
    document.body.appendChild(gtm_script);
  }
};

// Load the Google Maps API script
const loadGoogleMapsScript = () => {
  if (!document.getElementById('google-maps-script')) {
    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${getGoogleMapKey()}`;
    script.async = true;
    document.body.appendChild(script);
  }
};

const setWebStatusBarColor = (color = '#A8D6F2') => {
  try {
    if ((isWeb || isWebPlatform) && typeof document !== 'undefined') {
      if (document.body) {
        document.body.style.backgroundColor = color;
      }
      let metaTheme = document.querySelector('meta[name="theme-color"]');
      if (!metaTheme) {
        metaTheme = document.createElement('meta');
        metaTheme.setAttribute('name', 'theme-color');
        document.head.appendChild(metaTheme);
      }
      metaTheme.setAttribute('content', color);
    }
  } catch (e) {}
};

const NavigationTheme = {
  ...DefaultTheme,
  colors: { ...DefaultTheme.colors },
};

const rootPropTypes = {
  ready: PropTypes.bool,
  onReady: PropTypes.func,
};

const rootDefaultProps = {
  ready: false,
  onReady: () => {},
};

const Root = React.memo(
  ({ ready, onReady }) => {
    const dispatch = useDispatch();
    interceptorsSetup(dispatch);

    if (isNative) {
      // eslint-disable-next-line no-unused-vars
      const unsubscribe = NetInfo.addEventListener((state) => {
        const newInternet = state.isConnected; // && state.isInternetReachable;
        if (internet !== newInternet && !newInternet) {
          dispatch(
            AlertShow({
              show: true,
              title: 'No Internet',
              description: 'You seem to be offline, check your connection.',
              internet: true,
              isConfirm: false,
            }),
          );
        }
        if (!internet && newInternet) {
          dispatch(hideAlert());
          //Toast.show({ text1: `You're back online` });
        }
        internet = newInternet;
      });
    }

    const userAuth = useSelector((state) => state.auth.user);
    const isLoggedin = useSelector((state) => state.auth.isLoggedIn);
    const isLoading = useSelector((state) => state.modal.isLoading);
    const showAlert = useSelector((state) => state.global.showAlert);
    const popupImage = useSelector((state) => state.global.popupImage);
    const currentDomain = isWebPlatform ? window.location.hostname : '';
    const userRole = userAuth?.role?.code || userAuth?.role;

    const getUserMe = async () => {
      await dispatch(userMe());
      onReady(true);
    };

    const checkForceUpdate = async () => {
      if (!isNative) {
        return;
      }
      const platform = isIos ? 'b2b_ios' : 'b2b_android';
      const currentVersion = getVersion();
      dispatch(setAppVersion(currentVersion));
      try {
        const response = await msPublicApi.getAppVersions(platform);

        const versions = response?.data?.data ?? [];
        const mustUpdate = versions.filter(
          (v) =>
            v.is_active &&
            semverValid(v.version) &&
            semverValid(currentVersion) &&
            semverGt(v.version, currentVersion),
        );
        if (mustUpdate.length > 0) {
          const latest = mustUpdate.sort((a, b) =>
            semverGt(b.version, a.version) ? 1 : -1,
          )[0];
          setTimeout(() => dispatch(showForceUpdate(latest)), 0);
        }
      } catch (err) {
        console.error('[checkForceUpdate] error:', err);
      }
    };

    useEffect(() => {
      let isMounted = true;
      if (isMounted) {
        if (isNative && !IS_SIMULATOR) {
          crashlytics().log('App mounted.');
        }

        // B2B-4491: we need to generate on web and make sure the user still loggedin
        if (isWebPlatform) {
          const path = window.location.pathname;
          if (path == '/pdf-viewer') {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('t');
            if (token) {
              // If already logged-in skip this
              const existingToken = Cookies.get('B2B-SOCIOLLA-TOKEN', {
                domain: COOKIES_DOMAIN,
              });
              if (!existingToken) {
                Cookies.set('B2B-SOCIOLLA-TOKEN', JSON.stringify(token), {
                  domain: COOKIES_DOMAIN,
                  expires: COOKIES_EXPIRY,
                });
              }
            }
          }
        }

        getUserMe();
        if (isIos) {
          (async () => {
            const trackingStatus = await requestTrackingPermission();
            if (['authorized', 'unavailable'].includes(trackingStatus)) {
              console.log('Yay!, you give us permission!');
            }
          })();
        }
      }
      return () => {
        isMounted = false;
      };
    }, []);

    useEffect(() => {
      if (ready) {
        checkForceUpdate();
      }
    }, [ready]);

    useEffect(() => {
      if (isWebPlatform) {
        if (isLoggedin) {
          setWebStatusBarColor('#A8D6F2');
        } else {
          setWebStatusBarColor('#A8D6F2');
        }
      }
    }, [isLoggedin]);

    const redirectToNetDomain = () => {
      dispatch(logout());
      window.location.href = `https://${
        currentDomain.includes('uat') || currentDomain.includes('localhost')
          ? NET_DOMAIN[1]
          : NET_DOMAIN[0]
      }`;
    };

    useEffect(() => {
      if (global.pageFrom == 'LoginScreen' && isLoggedin) {
        try {
          if (global.pageBase) {
            // Add exception for 3PL
            if (isNative) {
              // Handle apps
              if (userRole == '3pl') {
                dispatch(logout());
              } else {
                global.pageBase.navigate('HomeNavigator', {
                  screen: 'HomeScreen',
                });
              }
            } else {
              if (NET_DOMAIN.includes(currentDomain)) {
                // Handle .net domain
                global.pageBase.navigate('ProfileNavigator', {
                  screen: 'ProfileScreen',
                  params: {
                    id: '',
                    name: '',
                    titleScreen: '',
                    branchId: '',
                    branchName: '',
                  },
                });
              } else {
                // Handle .info and uat domain
                if (userRole == '3pl') {
                  redirectToNetDomain();
                } else {
                  global.pageBase.navigate('HomeNavigator', {
                    screen: 'HomeScreen',
                  });
                }
              }
            }
          }
        } catch (err) {}
      } else if (global.pageFrom != 'LoginScreen' && isLoggedin) {
        if (isWebPlatform) {
          if (userRole == '3pl' && !NET_DOMAIN.includes(currentDomain)) {
            redirectToNetDomain();
          }
          if (NET_DOMAIN.includes(currentDomain)) {
            const fullPath = window.location.pathname;
            const paths = fullPath.split('/');
            const path = paths?.[1];
            if (
              ![
                'lembar-penerimaan-barang',
                'profile',
                'notifications',
              ].includes(path)
            ) {
              window.location.href = `https://${currentDomain}/profile`;
            }
          }
        }
      }
    }, [isLoggedin]);

    if (!ready) {
      return <FullLoader show={true} transparent={true} />;
    }

    return (
      <>
        {isLoggedin ? (
          <>
            <RootNavigator />
            {isLoading ? <FullLoader show={isLoading} /> : false}
            {!popupImage.isModal ? <ModalImage /> : false}
            <PortalHost name="button-sticky" />
          </>
        ) : (
          <AuthNavigator />
        )}
        {!showAlert.isModal ? <Alert /> : false}
        <ForceUpdateModal />
      </>
    );
  },
  (prev, next) => prev == next,
);

Root.propTypes = rootPropTypes;
Root.defaultProps = rootDefaultProps;

export default function App() {
  const navigationRef = useRef();
  const routeNameRef = useRef();

  const [isReady, setIsReady] = useState(false);
  const [fontLoaded, setFontLoaded] = useState(false);

  let isDevelopment = false;
  if (Platform.OS != 'web') {
    if (ENV != 'production') {
      isDevelopment = true;
    }
  }

  useEffect(() => {
    const prepare = async () => {
      try {
        await fetchAssets();
        await SyncStorage.init();
        store.dispatch(
          setLanguage(SyncStorage.get(LANGUAGE_STORAGE_KEY) || 'en'),
        );
      } catch (error) {
        console.warn('Error while preparing app:', error);
      } finally {
        setFontLoaded(true);
      }
    };

    prepare();
  }, []);

  // Hide native splash only when both assets are loaded and app is ready
  useEffect(() => {
    if (isNative && fontLoaded && isReady) {
      SplashScreen.hideAsync().catch(() => {});
    }
  }, [fontLoaded, isReady]);

  const setRoute = () => {
    if (navigationRef && routeNameRef) {
      const currentRoute = navigationRef?.current;
      if (!currentRoute) {
        return false;
      }
      const current = currentRoute.getCurrentRoute()?.name;
      const routeDetail = currentRoute.getCurrentRoute();
      const optionsDetail = currentRoute.getCurrentOptions();
      const previous = currentRoute;
      if (current != previous && current != 'LoginScreen') {
        logEventScreen(current);
      }
      if (isNative) {
        if (current !== previous) {
          store.dispatch(
            actionRoute({
              current,
              previous,
              route: routeDetail,
              options: optionsDetail,
            }),
          );
        }
      } else {
        store.dispatch(
          actionRoute({
            current,
            previous,
            route: routeDetail,
            options: optionsDetail,
          }),
        );
      }
      routeNameRef.current = current;
    }
  };

  const setCurrentRoute = async (value, isPrev = false) => {
    if (value) {
      const current = await AsyncStorage.getItem('B2B-CURRENT-ROUTE');
      const prev = await AsyncStorage.getItem('B2B-PREV-ROUTE');
      await AsyncStorage.setItem('B2B-CURRENT-ROUTE', JSON.stringify(value));
      if (isPrev) {
        let prevRoute = '';

        if (current) {
          prevRoute = JSON.parse(current);
        } else if (prev) {
          prevRoute = JSON.parse(prev);
        }

        if (current) {
          await AsyncStorage.setItem('B2B-PREV-ROUTE', current);
        }

        if (prevRoute) {
          const routes = navigationRef?.current?.getRootState()?.routes || [];
          const finalOptions = routes.find(
            (r) =>
              r.state?.routes?.findIndex((r2) => r2.name == prevRoute?.name) >
              -1,
          );
          await AsyncStorage.setItem(
            'B2B-LAST-ROUTE',
            JSON.stringify({
              ...(prevRoute || {}),
              navigator: finalOptions?.name,
            }),
          );
        }
      }
    }
  };

  if (!fontLoaded) {
    return null;
  } else {
    return (
      <>
        <Provider store={store}>
          <SafeAreaProvider>
            <NavigationContainer
              ref={navigationRef}
              theme={NavigationTheme}
              documentTitle={{
                formatter: (options, route) => {
                  const baseTitle = options?.title || route?.name || '';
                  if (!baseTitle) {
                    return '';
                  }

                  let cleaned = baseTitle.replace(/^V[\d.]+\s*\|\s*/i, '');
                  const isVietnam = isVn();
                  const companyName = isVietnam
                    ? 'Social Bella Vietnam Company Limited'
                    : 'PT Semesta Distribusi Indonesia';

                  if (cleaned.includes(' - ')) {
                    cleaned = cleaned.split(' - ')[0];
                  }

                  return `${cleaned} - ${companyName}`;
                },
              }}
              linking={{
                prefixes: [
                  'https://uat-b2b-apps.sociolabs.io',
                  'https://nina.sociolla.info',
                  'nina://',
                ],
                config: B2bRouting,
              }}
              onReady={() => {
                routeNameRef.current =
                  navigationRef?.current?.getCurrentRoute()?.name;
                global.pageFrom =
                  navigationRef?.current?.getCurrentRoute()?.name;
                // global.currentPage = navigationRef?.current?.getCurrentRoute();
                setCurrentRoute(navigationRef?.current?.getCurrentRoute());
                if (global.pageFrom != 'LoginScreen') {
                  global.pageBase = navigationRef?.current;
                }
                if (!isNative) {
                  createGtmScript();
                  loadGoogleMapsScript();
                  setWebStatusBarColor();
                }
              }}
              onStateChange={(state) => {
                global.pagePrevFrom = global.pageFrom;
                global.pageFrom =
                  navigationRef?.current?.getCurrentRoute()?.name;
                // global.previousPage = global.currentPage;
                // global.currentPage = navigationRef?.current?.getCurrentRoute();
                setCurrentRoute(
                  navigationRef?.current?.getCurrentRoute(),
                  true,
                );
                if (global.pageFrom != 'LoginScreen') {
                  global.pageBase = navigationRef?.current;
                }
                setRoute();
              }}>
              <PortalProvider>
                <StatusBar barStyle="light-content" />
                <Root
                  ready={isReady}
                  onReady={(status) => setIsReady(status)}
                />
                {isDevelopment ? (
                  <View
                    style={{
                      width: 100,
                      position: Platform.OS != 'web' ? 'absolute' : 'fixed',
                      bottom: 200,
                      left: -43,
                      paddingVertical: 3,
                      paddingHorizontal: 4,
                      borderTopRightRadius: 3,
                      borderTopLeftRadius: 3,
                      backgroundColor: Colors.blue1,
                      justifyContent: 'center',
                      alignItems: 'center',
                      transform: [{ rotate: '90deg' }],
                    }}>
                    <SociollaText
                      type="medium"
                      style={{
                        fontSize: 10,
                        color: Colors.white,
                        letterSpacing: 0.5,
                      }}>
                      UAT {VERSION}
                    </SociollaText>
                  </View>
                ) : (
                  false
                )}
              </PortalProvider>
              {isShowingLogger && (
                <NetworkLoggerFloating navigation={navigationRef} />
              )}
            </NavigationContainer>
          </SafeAreaProvider>
        </Provider>
        {/* <FAB /> */}
        <Toast {...TOAST_PROPS} config={TOAST_CONFIG} />
      </>
    );
  }
}
